import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Inject, OnInit, Optional, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "app/auth/auth.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { DynamicHelpListComponent } from "app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component";
import { EMRService } from "app/EMR/EMR.service";
import { SurgicalHistoryModel } from "app/EMR/HistoryModels/surgicalhistory.model";
import { NewSurgeryComponent } from "app/EMR/NewSurgery/NewSurgery.component";
import { HelplistService } from "app/helplist.service";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { Observable, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-surgical-history",
  templateUrl: "./surgical-history.component.html",
  styleUrls: ["./surgical-history.component.scss"],
})
export class SurgicalHistoryComponent implements OnInit {
  destroysugical$: Subject<boolean> = new Subject<boolean>();
  @Output() surgicalEmitter = new EventEmitter<() => void>();
  surgicalhistory_ds: MatTableDataSource<SurgicalHistoryModel>;
  displayedColumns_surgicalhistory: string[] = [
    "surgeryName",
    "surgeryDate",
    "surgeonName",
    "place",
    "remarks",
    "Action",
  ];
  private surgicalArrayList: any = [];
  private geSurgicaldata: any = [];
  private editCache: { [key: string]: any } = {};
  private surgeryTypeCtrl = new FormControl();
  private filteredsurgeryTypeArray: Observable<any[]>;
  private filteredDoctorArray: Observable<any[]>;
  private filteredPlaceArray: Observable<any[]>;
  private DoctorCtrl = new FormControl();
  private placeCtrl = new FormControl();
  private placelist: any;
  // private emrservice.enabledisablebtnsurhistory: boolean = false;
  private updateBtndisable: boolean = true;
  private EditId: any;
  private eyeProcList: any;
  isheader: boolean = false;
  showspinner: boolean = false;
  constructor(
    private emrservice: EMRService,
    private helplistservice: HelplistService,
    private authService: AuthService,
    private opdvisitService: OpdVisitService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dashboardService: DashboardService,
    private dialogRef: MatDialogRef<SurgicalHistoryComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
  ) { }

  ngOnInit(): void {
    const surgi_historyFun = () => {
      console.log('Function called from the Child Component');
      this.get_All_surgeries();
    };
    this.surgicalEmitter.emit(surgi_historyFun);

    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.emrservice.enabledisablebtnsurhistory = true;
    this.surgicalhistory_ds = new MatTableDataSource(
      this.emrservice.surgicalhistory.slice()
    );
    if (this.emrservice.surgicalhistory.length > 0) {
      this.surgicalArrayList = this.emrservice.surgicalhistory;
      this.emrservice.enabledisablebtnsurhistory = this.emrservice.surgicalhistory.filter(item => item.pkTranId == 0).length > 0 ? false : true;
    }
    this.emrservice.share.pipe(takeUntil(this.destroysugical$)).subscribe((x: any) => {
      if (x == 3) {
        this.get_All_surgeries();
      }
    });
    this.SurgeryTypeControll();
    this.doctorControll();
    this.updateEdit();
    this.placeListall(18);
    this.eyeProc();

  }
  eyeProc() {
    this.emrservice.getEyeProc().subscribe((data) => {
      this.eyeProcList = data;
      if (this.eyeProcList.length > 0) {
        this.updateBtndisable = false;
      }
    });
  }
  previousHistoy() {
    this.eyeProcList.forEach((item) => {
      let surgeryname = '';

      if (item.remarks && !['nil', 'nill', 'na'].includes(item.remarks.toLowerCase())) {
        surgeryname = `${item.surgeryName} (${item.remarks})`;
      } else {
        surgeryname = item.surgeryName;
      }
      this.surgicalArrayList.push({
        pkTranId: 0,
        fkRegId: this.opdvisitService.patientdetails.pkRegId,
        surgeryName: surgeryname,
        surgeryDate: item.surgeryDate,
        surgeonName: item.surgeon,
        place: "",
        remarks: "",
        pkSynchId: null,
        fK_SurgeryId: item.fK_SurgeryId,
        fK_SurgeonId: item.fK_SurgeonId,
      });
    });
    var results = this.surgicalArrayList.reduce((unique, o) => {
      if (
        !unique.some(
          (obj) =>
            Date.parse(
              this.datePipe.transform(obj.surgeryDate, "yyyy-MM-dd").toString()
            ) ==
            Date.parse(
              this.datePipe.transform(o.surgeryDate, "yyyy-MM-dd").toString()
            ) && obj.surgeryName.toLowerCase() == o.surgeryName.toLowerCase()
        )
      ) {
        unique.push(o);
      }
      return unique;
    }, []);

    this.surgicalhistory_ds.data = results;
    this.updateEdit();
    this.emrservice.enabledisablebtnsurhistory = false;
  }
  get_All_surgeries() {
    this.emrservice.get_surgeries(this.emrservice.visitid).pipe(takeUntil(this.destroysugical$)).subscribe(
      (data) => this.success_allsurgeries(data),
      (err) => this.failed_allsurgeries(err)
    );
  }

  success_allsurgeries(data) {
    this.surgicalArrayList = [];
    this.geSurgicaldata = [];
    if (data.length > 0) {
      this.emrservice.enabledisablebtnsurhistory = data.filter(item => item.pkTranId == 0).length > 0 ? false : true;
      this.surgicalhistory_ds.data = [];
      data.forEach((item) => {
        this.geSurgicaldata.push({
          pkTranId: item.pkTranId,
          fkRegId: item.fkRegId,
          surgeryName: item.surgeryName,
          surgeryDate: item.surgeryDate,
          surgeonName: item.surgeonName,
          place: item.place,
          remarks: item.remarks,
          pkSynchId: item.pkSynchId,
          fK_SurgeryId: item.pkSurgeryId,
          fK_SurgeonId: item.fK_SurgeonId ? item.fK_SurgeonId : 0,
        });
      });
      this.surgicalhistory_ds.data = this.geSurgicaldata;
      this.surgicalArrayList = this.surgicalhistory_ds.data;

    } else {
      this.surgicalhistory_ds.data = [];
    }
    this.updateEdit();
  }

  failed_allsurgeries(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  deletesurgery(row) {
    if (this.emrservice.surgicalhistoryPermission?.isDeletePermission == true) {
      if (row.pkTranId > 0) {
        this.emrservice.delete_surgery_on_server(row.pkTranId).pipe(takeUntil(this.destroysugical$)).subscribe(
          (data) => this.success_delete_surgeryhistory(data),
          (err) => this.failed_delete_surgeryhistory(err)
        );
      } else {
        const index: number = this.surgicalhistory_ds.data.indexOf(row);
        if (index !== -1) {
          this.surgicalhistory_ds.data.splice(index, 1);
          this.surgicalhistory_ds.data = this.surgicalhistory_ds.data;
        }
      }
    } else {
      this.dashboardService.openSnackBar("Delete permission denied", "OK");
    }
  }
  success_delete_surgeryhistory(data) {
    this.emrservice.enabledisablebtnsurhistory = true;
    this.get_All_surgeries();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.dashboardService.openSnackBar("Surgery successfully deleted", "OK");

  }
  failed_delete_surgeryhistory(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  newsurgery() {
    if (this.emrservice.surgicalhistoryPermission?.isAddPermission === true) {
      const dialogRef = this.dialog.open(NewSurgeryComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        width: "90%",
        data: {
          // id: this.dashboardService.pid,
          // userid: this.authService.Loggeduser.userid
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result.length > 0) {
          this.emrservice.enabledisablebtnsurhistory = false;

          result.forEach((item) => {
            let surgerynameEye = item.surgeryName;
            const surgeryNameLower = item.surgeryName.toLowerCase();

            if (surgeryNameLower !== 'nil' && surgeryNameLower !== 'nill' && surgeryNameLower !== 'na') {
              surgerynameEye = `${item.surgeryName} (${item.eye})`;
            }

            this.surgicalArrayList.push({
              pkTranId: item.pkTranId ? item.pkTranId : 0,
              fkRegId: item.fkRegId,
              surgeryName: surgerynameEye,
              surgeryDate: item.SurgeryDate,
              surgeonName: item.SurgeonName,
              place: item.place,
              remarks: item.remarks,
              pkSynchId: item.pkSynchId,
              fK_SurgeryId: item.pkSurgeryId,
              fK_SurgeonId: item.fK_SurgeonId ? item.fK_SurgeonId : 0,
            });
          });
        }

        const results = this.surgicalArrayList.reduce((unique, o) => {
          const isDuplicate = unique.some((obj) => {
            const objDate = this.datePipe.transform(obj.surgeryDate, 'yyyy-MM-dd');
            const oDate = this.datePipe.transform(o.surgeryDate, 'yyyy-MM-dd');

            return (
              obj.surgeryName.toLowerCase() === o.surgeryName.toLowerCase() &&
              objDate === oDate
            );
          });

          if (!isDuplicate) {
            unique.push(o);
          }

          return unique;
        }, []);

        this.surgicalhistory_ds.data = results;
        this.updateEdit();
      });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  save_surgeries() {

    this.surgicalhistory_ds.data.map(item => item.fk_VisitID = this.opdvisitService.visitid);
    let payload = this.surgicalhistory_ds.data;
    if (this.surgicalhistory_ds.data.length > 0) {
      // this.emrservice.open_loader_Dialog();
      this.showspinner = true;
      this.emrservice.save_surgeries(payload).pipe(takeUntil(this.destroysugical$)).subscribe(
        (data) => this.success_surgeries_saved(data),
        (err) => this.failed_surgeries_saved(err)
      );
    } else {
      // this.dialog.closeAll();
      this.dashboardService.openSnackBar("Please Select Surgery", "OK");
    }
  }
  success_surgeries_saved(data) {
    this.surgicalArrayList = [];
    this.emrservice.enabledisablebtnsurhistory = true;
    this.showspinner = false;
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.get_All_surgeries();
    this.emrservice.surgicalhistory_client = [];
    if (data.length > 0 || data.statusCode == 1) {
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    }
    else if (data.statusCode == 10) {
      this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
    }
  }
  failed_surgeries_saved(err) {
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  updateEdit(): void {
    this.surgicalhistory_ds.data.forEach((item, index) => {
      const id = index;
      this.editCache[id] = {
        edit: false,
        data: { ...item },
      };
    });
  }

  // Edit(index) {
  //   if (this.emrservice.surgicalhistoryPermission?.isModifyPermission == true) {
  //     const id = index;
  //     this.EditId = id;
  //     this.updateEdit();
  //     this.editCache[id].edit = true;
  //     this.editCache[id].data.surgeryDate = this.datePipe
  //       .transform(this.editCache[id].data.surgeryDate, "yyyy-MM-dd")
  //       .toString();
  //   } else {
  //     this.dashboardService.openSnackBar("Modify permission denied", "OK");
  //   }
  // }
  // saveEdit(idx): void {
  //   const id = idx;
  //   let payloadarray = [];
  //   let editpayload;
  //   let surgeryDate;
  //   let editlist = this.editCache[id].data;
  //   if (editlist.surgeryDate != null) {
  //     surgeryDate = this.datePipe
  //       .transform(editlist.surgeryDate, "yyyy-MM-dd")
  //       .toString();
  //   }
  //   payloadarray.push({
  //     pkTranId: editlist.pkTranId,
  //     fkRegId: editlist.fkRegId,
  //     surgeryName: editlist.surgeryName,
  //     surgeryDate: surgeryDate,
  //     surgeonName: editlist.surgeonName,
  //     place: editlist.place,
  //     remarks: editlist.remarks,
  //     pkSynchId: editlist.pkSynchId,
  //     fK_SurgeryId: editlist.pkSurgeryId,
  //     fK_SurgeonId: editlist.fK_SurgeonId ? editlist.fK_SurgeonId : 0,
  //   });
  //   this.editCache[id].edit = false;
  //   editpayload = payloadarray;
  //   this.emrservice.save_surgeries(editpayload).pipe(takeUntil(this.destroysugical$)).subscribe(
  //     (data) => this.success_surgeries_saved(data),
  //     (err) => this.failed_surgeries_saved(err)
  //   );
  // }

  // cancelEdit(idx): void {
  //   const id = idx;
  //   this.editCache[id].edit = false;
  // }

  placeListall(type: any) {
    this.emrservice.GetPopupMasterHelp(type).subscribe((x: any) => {
      let datalist = x;
      this.placelist = datalist.filter((item) => item.isActive == true);
      this.placeControl();
    });
  }

  placeControl() {
    this.filteredPlaceArray = this.placeCtrl.valueChanges.pipe(
      startWith(""),
      map((e) => (e ? this.filterdplace(e) : this.placelist.slice()))
    );
  }

  filterdplace(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.placelist.filter(
      (item) => item.popupDescription?.toLowerCase().indexOf(filterValue) === 0
    );
  }

  SurgeryTypeControll() {
    this.filteredsurgeryTypeArray = this.surgeryTypeCtrl.valueChanges.pipe(
      startWith(""),
      map((item) =>
        item
          ? this.filterOpfunction(item)
          : this.helplistservice.surgeryList.slice()
      )
    );
  }

  filterOpfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.helplistservice.surgeryList.filter(
      (item) => item.surgeryName?.toLowerCase().indexOf(filterValue) === 0
    );
  }

  doctorControll() {
    this.filteredDoctorArray = this.DoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((e) =>
        e ? this.filterdoctorfunction(e) : this.opdvisitService.doctors.slice()
      )
    );
  }

  filterdoctorfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.opdvisitService.doctors.filter(
      (country) => country.userName?.toLowerCase().indexOf(filterValue) === 0
    );
  }
  getToday(): string {
    return this.authService.getServerDate;
  }
  refReasonPOpups(parameter, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "33vw",
      disableClose: true,
      width: "33%",

      data: {
        parametertype: parameter,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != 0) {
        if (type == 1) {
          this.editCache[this.EditId].data.remarks = result;
        }
      }
    });
  }
  ngOnDestroy() {

    this.destroysugical$.next(true);
    this.destroysugical$.unsubscribe();
    this.editCache = null;
    this.filteredsurgeryTypeArray = null;
    this.surgicalArrayList = null;
    this.geSurgicaldata = null;
    this.surgeryTypeCtrl = null;
    this.filteredDoctorArray = null;
    this.filteredPlaceArray = null;
    this.DoctorCtrl = null;
    this.placeCtrl = null;
    this.displayedColumns_surgicalhistory = null;
    console.log("destory surgical-history");
  }
  closedialog() {
    this.dialogRef.close();
  }
}
